@if (pwaInstall.canOffer()) {
  <button type="button" appButton variant="primary" size="sm" [fullWidth]="fullWidth()" (click)="install()">
    {{ "pwaInstall.button" | translate }}
  </button>
}

<ng-template #iosGuide let-modal>
  <div class="modal-body p-4">
    <h2 id="pwa-ios-guide-title" class="h5 mb-3">{{ "pwaInstall.iosGuideTitle" | translate }}</h2>

    <ol class="ps-3 mb-4">
      <li class="mb-2">{{ "pwaInstall.iosStepShare" | translate }}</li>
      <li class="mb-2">{{ "pwaInstall.iosStepMore" | translate }}</li>
      <li class="mb-2">{{ "pwaInstall.iosStepAdd" | translate }}</li>
      <li>{{ "pwaInstall.iosStepWebApp" | translate }}</li>
    </ol>

    <button type="button" appButton variant="primary" fullWidth (click)="modal.close()">
      {{ "pwaInstall.iosGuideClose" | translate }}
    </button>
  </div>
</ng-template>
